import { clearPhone } from '@/services/string';
import BaseService from '@/services/base_service';

export default class ConsultationService extends BaseService {

    list(params) {
        return new Promise((resolve, reject) => {
            axios.get('/consulta', params).then(response => {
                resolve(response);
            }).catch(e => {
                reject(e);
            });
        });
    }

    get(id) {
        return new Promise((resolve, reject) => {

            axios.get('/consulta/' + id).then(response => {
                resolve(response);
            }).catch(e => {
                reject(e);
            });
        });
    }

    create(model) {
        return new Promise((resolve, reject) => {
            model.telefone = clearPhone(model.telefone);
            axios.post('/consulta', model).then(response => {
                resolve(response);
            }).catch(e => {
                reject(this.getErrors(e));
            });
        });
    }

    update(model, id) {
        return new Promise((resolve, reject) => {
            model.telefone = clearPhone(model.telefone);
            axios.put('/consulta/' + id, model).then(response => {
                resolve(response);
            }).catch(e => {
                reject(e);
            });
        });
    }

    delete(id) {
        return new Promise((resolve, reject) => {
            axios.delete('/consulta/' + id).then(response => {
                resolve(response);
            }).catch(e => {
                reject(e);
            });
        });
    }

}



// WEBPACK FOOTER //
// ./src/services/consultation.js